import { PlanTrialOffer } from "@/react/components/Layout/TrialBanner/PlanTrialOffer";
import { TrialOffer } from "@/react/components/Layout/TrialBanner/TrialOffer";
import { usePlanTrialBanner } from "@/react/components/Layout/TrialBanner/usePlanTrialBanner";
import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { usePunditUserContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { HelloBar } from "@circle-react-uikit/HelloBar";
import { CancellationBanner } from "./CancellationBanner";

export const TrialBannerV2 = () => {
  const { displayCommunitySwitcher: shouldDisplayCommunitySwitcher } =
    usePunditUserContext();
  const { shouldShowTrialBanner, isSubscriptionCancelled } = useTrialBanner();
  const { isPlanTrialActive, shouldShowPlanTrialBanner } = usePlanTrialBanner();

  const shouldShowBanner = shouldShowTrialBanner || shouldShowPlanTrialBanner;

  if (!shouldShowBanner) {
    return null;
  }

  const renderBannerContent = () => {
    if (isSubscriptionCancelled) {
      return <CancellationBanner />;
    }
    if (isPlanTrialActive) {
      return <PlanTrialOffer />;
    }
    return <TrialOffer />;
  };

  return (
    <HelloBar
      className={classNames({
        "left-[60px]": shouldDisplayCommunitySwitcher,
        "!bg-warning-light": !isSubscriptionCancelled,
      })}
    >
      {renderBannerContent()}
    </HelloBar>
  );
};
